import type { ChildGuideItem } from '@tunein/web-api-client';
import { getGuideItemPathnameWithLogger } from './guideItem/getGuideItemPathname';

export function generateRoutePathForGuideItem(logger: any) {
  return (guideItem: ChildGuideItem) => {
    return getGuideItemPathnameWithLogger(guideItem)(logger);
  };
}
